import { AbstractControl, ValidatorFn } from '@angular/forms'
import { DirectusUsers, Group } from 'src/types'

export const DIRECTUS_STORAGE = 'directus_storage'

export enum TokenData {
  AccessToken = 'access_token',
  Expires = 'expires',
  ExpiresAt = 'expires_at',
  RefreshToken = 'refresh_token'
}

export interface ITokenData {
  [TokenData.AccessToken]: string
  [TokenData.Expires]: number
  [TokenData.ExpiresAt]: number
  [TokenData.RefreshToken]: string
}

export const LOCAL_STORAGE_KEYS = {
  [DIRECTUS_STORAGE]: TokenData
}

export enum UserRole {
  Teacher = 'Teacher',
  Student = 'Student',
  ContentManager = 'Content Manager',
  UserAdmin = 'User Admin'
}

export enum ValidatorPatterns {
  Email = "^[a-zA-Z0-9._%'+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
  Password = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
}

export const passwordMatchingValidator: ValidatorFn = (control: AbstractControl) => {
  const password = control.get('password')
  const confirmPassword = control.get('confirmPassword')

  return password?.value === confirmPassword?.value ? null : { notMatched: true }
}

export type AddUser = Pick<DirectusUsers, 'first_name' | 'last_name' | 'email' | 'password' | 'confirmed'>

export enum ValidationMessages {
  PasswordsNotMatch = "Passwords don't match",
  PasswordRequired = 'Password is required',
  PasswordRequirements = 'Password must contain at least 3 characters.',
  EmailNotValid = 'Email is not valid',
  EmailRequired = 'Email is required',
  LastNameRequired = 'Last name is required',
  FirstNameRequired = 'First name is required'
}

export interface StudentClass {
  id: string
  name: string
  isPending: boolean
  orgId?: string
}
